import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Field, } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';
import PrintIcon from '@material-ui/icons/Print';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],
      professional: {},
      addedDiagnostics: [],
      openModal: false,
      loadProfessionals: false,
      conclusion: "",
      profile: sessionStorage.getItem('perfil'),
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.professional != null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.professional) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty, professional: this.props.professional, loadProfessionals: false }, () => {
              //this.props.handlerMedicalProcedures("Map", "professional", this.props.professional);
            });
          }
        });
      })
        .catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };


  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    this.setState({ professional: professional });
  }

  handlerConclusion = (conclusion) => {
    this.setState({ conclusion: conclusion });
  }

  saveProcedure() {

    const day = new Date();
    const data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      fecha: moment(day).format("YYYY-MM-DD"),
      hora: moment(day).format('LT'),
      eco: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        ao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        description: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: "",
      },
      stress: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        resposo: "",
        ejercicio: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      prueba: {
        professional: "",
        conclusiones: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      ekg: {
        professional: "",
        ritmo: "",
        fc: "",
        ondaP: "",
        pr: "",
        qr_s: "",
        eje_qrs: "",
        styt: "",
        qtc: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      holter: {
        professional: "",
        conclusion: "",
        medicament: "",
        descripcion_d: ""
      },
      map: {
        professional: this.props.professional.nombres + " " + this.props.professional.apellido1,
        conclusion: this.state.conclusion,
        diagnostico: this.state.addedDiagnostics,
        descripcion_d: ""
      },
    }

    fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        alert("procedimiento creado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL +'/pages/search-clinic-history',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  render() {   

    return (<Col>
      <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
        <div className="card__title">
          <h5 className="bold-text">Mapa</h5>
        </div>

        <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
          <TextField
            required
            disabled
            id="specilaity-standard-required"
            label="Especialidad"
            type="text"
            value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad }
            onChange={(e) => {
              this.handlerSpeciality(e.target.value);
            }}
          />
          <TextField
            required
            disabled
            id="professional-standard-required"
            label="Profesional"
            type="text"
            value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
            onChange={(e) => {
              this.handlerProfessional(e.target.value);
            }}
          />
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Conclusión</span>
          <div className="form__form-group-field">
          <textarea
              name="textarea-conclusion-MAP" rows="10" cols="50"
              defaultValue={this.props.dataProcedure.conclusion}
              onChange={(e) => {

                this.props.handlerMedicalProcedures("Map", "conclusion", e.target.value);
                this.handlerConclusion(e.target.value)

              }}>
            </textarea>
          </div>
        </div>
      </div>

      {this.state.profile === "12" || this.state.profile === "4" ?
        (<Button
          style={{ marginTop: 20 }}
          variant="contained"
          color="primary"
          onClick={() => {
            this.saveProcedure();
          }}
        > Guardar Procedimieto
        </Button>) : null
      }
      <Button
        style={{ marginTop: 20, marginLeft: 20 }}
        variant="contained"
        color="primary"
        startIcon={<PrintIcon />}
      > Imprimir
      </Button>
    </Col>);
  }
}

export default Map;